<template>
  <div  :id="id" :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import  echarts from 'echarts';
import resize from "./mixins/resize";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    id: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "200px",
    },
    height: {
      type: String,
      default: "200px",
    },
    pieData:{
      type:Object,
      default: ()=>{
        return {}
      }
    }
  },
  watch:{
    pieData:{
      handler(newVal){
        if(newVal.series){
          // this.pieOption.series = newVal.series
          // this.pieOption.xAxis = newVal.xAxis
          // this.pieOption.yAxis = newVal.yAxis
          // this.legend
          this.pieOption = newVal;
          this.$nextTick(()=>{
            this.chart.setOption(this.pieOption)
          })
         
        }
      },
      deep:true,
      immediate: true
    }
  },
  data() {
    return {
      chart: null,
      pieOption:{
        series: [],
        yAxis: {
    type: 'value'
  },
  xAxis: {
  },
      },
    };
  },
  mounted(){
this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {

         this.chart = echarts.init(document.getElementById(this.id))
    },
  },
};
</script>
